import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import { cardImages } from 'utils/constants';

import * as S from './styled/CreditCard.styled';

const CreditCard = ({ onClick, lastFour, cardBrand, month, year, isSelected, ...rest }) => (
	<S.Container onClick={onClick} className={isSelected ? 'selected' : ''} {...rest}>
		<Image width="4rem" height="4rem" url={cardImages[cardBrand?.toLowerCase()]} alt="card" />

		<S.CardNumber>
			{[...Array(3)].map((_, i) => (
				<Typography variant="caption" fontWeight="500" color="var(--black-70)" key={i}>
					••••
				</Typography>
			))}

			<Typography variant="caption" fontWeight="500">
				{lastFour}
			</Typography>
		</S.CardNumber>

		{month && year && (
			<S.CardExpiry>
				<Typography variant="caption" color="var(--black-70)">
					expiry
				</Typography>
				<Typography variant="caption" fontWeight="500" color="var(--black-70)">
					{`${month} / ${year}`}
				</Typography>
			</S.CardExpiry>
		)}
	</S.Container>
);

export default CreditCard;
